import React from "react";
import SharedDonut from "../../common/DonutChart";
import { BRAND, STATUS_COLORS, getPaletteColor } from "../../../utils/chartTheme";

const DonutChartWithSideData = ({ data, centerValue, centerLabel }) => {
  const allStatusData = [
    {
      name: "Completed",
      value: data?.completedFeatures || 0,
      color: STATUS_COLORS.completed,
    },
    {
      name: "Pending",
      value: data?.pendingFeatures || 0,
      color: STATUS_COLORS.planned,
    },
    {
      name: "Monitored",
      value: data?.monitoredFeaturesCount || 0,
      color: BRAND.teal,
    },
    {
      name: "Not Monitored",
      value: Math.max(
        0,
        (data?.totalBOQs || 0) - (data?.monitoredFeaturesCount || 0)
      ),
      color: getPaletteColor(2),
    },
  ];

  return (
    <SharedDonut
      items={allStatusData}
      centerValue={typeof centerValue === "number" ? centerValue : undefined}
      centerLabel={centerLabel}
    />
  );
};
const FunctionalStatusDonutChart = ({ data, centerValue, centerLabel }) => {
  const allStatusData = [
    {
      name: "Fully Functional",
      value: data?.fullyFunctional || 0,
      color: BRAND.teal,
    },
    {
      name: "Partially Functional",
      value: data?.partiallyFunctional || 0,
      color: BRAND.gold,
    },
    {
      name: "Non-Functional",
      value: data?.nonFunctional || 0,
      color: getPaletteColor(4),
    },
  ];

  return (
    <SharedDonut
      items={allStatusData}
      centerValue={typeof centerValue === "number" ? centerValue : undefined}
      centerLabel={centerLabel}
    />
  );
};
const FunctionalStatusWidget = ({ apiData, loading }) => {
  if (loading) {
    return (
      <div className="bg-white animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/4 mb-4"></div>
        <div className="h-48 bg-gray-100 rounded"></div>
      </div>
    );
  }

  if (!apiData || !apiData.success || !apiData.data?.functionalStatus) {
    return (
      <div className="bg-white ">
        <h3 className="text-lg font-semibold text-gray-800 text-balance">
          Functional Status
        </h3>
        <div className="text-center py-8 text-gray-500">
          No functional status data available
        </div>
      </div>
    );
  }

  const data = apiData.data;
  const functionalData = data.functionalStatus;
  const totalAssessed = data.totalFeaturesAssessed || 0;
  const functionalRate = parseFloat(data.functionalRate || 0);
  const chartData = {
    fullyFunctional: functionalData["Fully Functional"]?.count || 0,
    partiallyFunctional: functionalData["Partially Functional"]?.count || 0,
    nonFunctional: functionalData["Non-Functional"]?.count || 0,
    totalAssessed: totalAssessed,
  };

  return (
    <div className="bg-white ml-10">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-800 mt-1 text-balance">
          Functional Status Functional Rate ({functionalRate}%)
        </h3>
      </div>
      <div className="mb-2 mt-3">
        <FunctionalStatusDonutChart
          data={chartData}
          centerValue={totalAssessed}
          centerLabel="Total"
        />
      </div>
    </div>
  );
};

export default FunctionalStatusWidget;
export { DonutChartWithSideData, FunctionalStatusDonutChart };
